/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.49
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UnscheduleBookableRequest
 */
export interface UnscheduleBookableRequest {
    /**
     * ISO8601 local date string, e.g. "2026-03-19"
     * @type {string}
     * @memberof UnscheduleBookableRequest
     */
    localDate: string;
}

/**
 * Check if a given object implements the UnscheduleBookableRequest interface.
 */
export function instanceOfUnscheduleBookableRequest(value: object): value is UnscheduleBookableRequest {
    if (!('localDate' in value) || value['localDate'] === undefined) return false;
    return true;
}

export function UnscheduleBookableRequestFromJSON(json: any): UnscheduleBookableRequest {
    return UnscheduleBookableRequestFromJSONTyped(json, false);
}

export function UnscheduleBookableRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UnscheduleBookableRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'localDate': json['localDate'],
    };
}

export function UnscheduleBookableRequestToJSON(value?: UnscheduleBookableRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'localDate': value['localDate'],
    };
}

